// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__0g6L2","priceMobile":"Heading_priceMobile__wwMfJ","address":"Heading_address__CVMT7","verified":"Heading_verified__FvaGT"};